import {
    EventEmitter
} from '../EventEmitter'
import {
    v4 as uuidv4
} from 'uuid';

import { encrypt } from '../utils/tools.js'

/**
 * 创建应用
 */
export class createApp extends EventEmitter {
    appName = null;
    category = null;
    autostart = false;
    singleton = true;
    proc = null;
    active = false; //是否活动
    hidden = false;
    icon = null;

    showTitle = true; //是否显示标题

    mimes = [
        "^image\/(.*)",
        "^video\/(.*)"
    ]

    windowType = 'normal'; //full window

    files = [];

    _matedata = {}

    constructor(matedata, proc, Applications) {
        super();
        this.proc = proc;
        this.$root = proc.$root;
        this.data = proc.data;
        this.appName = matedata.name;
        this.category = matedata.category;
        this.alias = matedata.alias;
        this.autostart = matedata.autostart ?? false;
        this.singleton = matedata.singleton ?? true;
        this.hidden = matedata.hidden ?? false;
        this.icon = matedata.icon;
        this.showTitle = matedata.showTitle ?? true;
        this.mimes = matedata.mimes;
        this.files = matedata.files;
        this.Applications = Applications;
        this.openInIframe = matedata.openInIframe ?? false;

        this.full = false;
        this.url = matedata.url;
        // if (this.openInIframe) {
        //     this.url = `./packages/${this.appName}/${matedata.launch}`;
        // }

        this.uuid = uuidv4();
        this.before = matedata.before

        this._matedata = matedata;
    }

    
    get $el() {
        return this._content;
    }

    set $el(val) {
        if (val instanceof HTMLElement) {
            this._content = val;
        } else if (typeof val === 'string') {
            this._content = document.createElement(val);
        }
    }

    /**
     * 向指定应用发送消息
     * @param {string} appname 
     * @param {object} message 
     */
    send(appname, message) {
        let apps = this.Applications;
        Object.keys(apps).forEach(key => {
            if (appname == apps[key].app.appName) {
                apps[key].app.emit('message', {
                    uuid: this.uuid,
                    from: this.appName,
                    ...message
                });
            }
        })
    }

    /**
     * 创建可拖动的窗口
     * @param {Object} options 
     * @returns 
     */
    createWindow(options) {
        if (this.hidden) return;
        this.windowType = 'window'
        this.windowOptions = options
        this.window = this.proc.createWindow({
            ...options, ...{
                events: {
                    closed: function () {
                        this.destroy();
                    }
                }
            }
        });
        return this.window;
    }


    /**
     * 创建全屏窗口
     * @param {Onject} param 
     * @returns 
     */
    createFullWindow(param) {
        if (this.hidden) return;
        this.param = param;
        this.windowType = 'full'
        this._content = document.createElement('div');
        this._content.id = 'full-window';
        this._content.setAttribute('data-uuid', this.uuid);
        this.setStyle({
            position: 'fixed',
            inset: 0,
            overflow: 'hidde',
            display: 'none',
        })

        let titleBar = document.createElement('div');

        let insideContent = this.createInsideContainer();

        // 存在容器元素

        switch (typeof param?.container) {
            case 'string':
                // 多个容器
                this.$root = document.querySelector(param)
                break;
            case 'object':
                this.$root = param.container;
                break;
        }


        if (this.showTitle) {
            titleBar.className = 'title-bar';
            titleBar.id = 'title-bar';
            titleBar.innerHTML = /* html */ `<div class="title-bar-left">
            <div class="title-bar-icon">
                <i class="iconfont icon-arrow-left"></i>
            </div>
            <div class="title-bar-title">${this.alias ? this.alias : this.appName}</div>
        </div>
        <div class="title-bar-right">
            <div class="title-bar-icon">
                <i class="iconfont icon-guanbi"></i>
            </div>
        </div>`;
            this._content.appendChild(titleBar);

            titleBar.querySelector('.icon-guanbi').addEventListener('click', () => {
                this.close();
            })

        }

        this._content.appendChild(insideContent);

        this.full = true;

        if (this.autostart) {
            this.open(param);
        }
        this.emit('full-window-created', insideContent);

        if (typeof arguments[0] == 'function') {
            arguments[0](insideContent);
        }
        if (arguments.length > 0 && typeof arguments[1] == 'function') {
            this.param = arguments[0];
            arguments[1](insideContent);
        }
        return insideContent;
    }

    createInsideContainer() {
        let insideContent = document.createElement('div');
        this.insideContent = insideContent;

        insideContent.className = 'inside-content';
        if (this.showTitle) {
            insideContent.style.cssText = `
            height: calc(100% - ${50}px);
            width: 100%;
        `
        }
        return insideContent;
    }

    /**
     * 从iframe打开
     * @param {string} 打开的地址
     */
    openIframe(url, param) {
        // 创建iframe窗口
        let iframe = document.createElement('iframe');
        iframe.className = 'app-run-the-container';
        iframe.scrolling = 'no';
        // let h = titleBar.offsetHeight;

        iframe.onload = () => {
            this.emit('Application.load');
        }
        iframe.onerror = () => {
            this.emit('Application.error');
        }


        this.$iframe = iframe;
        this.loadUrl(url);

        this.$root.appendChild(iframe)

        return iframe
    }


    /**
     * 加载新的链接
     * @param {string} url 
     */
    loadUrl(url) {
        this.$iframe.src = url;
    }

    hide(){
        if(!this._content)return;
        this._content.style.display = 'none';
    }
    show(){
        this._content.style.display = 'block';
    }
    /**
     * 关闭应用
     * @returns 
     */
    close() {
       
        if (!this.active) return;
        this.emit('Application.destroy',this);
        this.proc.emit('Application.destroy',this)
        if (this._content) {
            this._content.remove();
            this._content = undefined;
        }
        this.active = false;
        if (encrypt.decrypt(this.proc.getLinkAppName(), this.proc.key) == this.appName) {
            window.close()
        }
        if (this.window) {
            this.window.signals.on('closed', function () {
                this.destroy();
            });
        }
    }

    // 启动或关闭应用
    toggle(param) {
        // this.active = !this.active;
        if (!this.active) {
            this.open(param)
        } else {
            this.close()
        }
    }

    getStyle() {
        // 获取样式
        let style = {};
        if (this._content) {
            let styleStr = this._content.getAttribute('style');
            if (styleStr) {
                styleStr.split(';').forEach(item => {
                    let [key, value] = item.split(':');
                    style[key] = value;
                })
            }
        }
        return style;
    }

    setStyle(style) {
        if (this._content) {
            let css = '';
            for (let key in style) {
                css += `${key}:${style[key]};`
            }
            this._content.style.cssText = css;
        }
    }
    // 针对full窗口的操作
    minimize() {
        this._content.style.display = 'none';
    }
    // 针对full窗口的操作
    maximize() {
        this._content.style.display = 'block';
    }

    /**
     * 打开应用
     * @param {any} param 
     * @returns 
     */
    open(param) {
        this.param = param;

        let before = this.before ? this.before() : true;

        if (this.active || !before) return;

        switch (this.windowType) {
            case 'window':
                // 可拖动窗口模式
                this.window.open();
                break;
            case 'full':
                // 是否修改样式
                if (param?.style && typeof param.style === 'object') {
                    Object.keys(param.style).forEach(key => {
                        this._content.style[key] = param.style[key];
                    })
                }
                // 是否是单例模式
                if (this.singleton) {
                    let allWindow = document.querySelectorAll(`[data-uuid="${this.uuid}"]`);
                    // 如果和页面上已经存在实例则不在创建新的额实例
                    if (allWindow.length) {
                        allWindow.forEach(item => {
                            item.style.display = 'block';
                        })
                    } else {
                        this._content.style.display = 'block';
                        if (!this.hidden) {
                            this.$root.appendChild(this._content);
                        }
                    }
                } else {
                    this._content.style.display = 'block';
                    if (!this.hidden) {
                        this.$root.appendChild(this._content);
                    }
                }
                break;
        }
        this.active = true;
        this.emit('Application.open', param);
        // 应用启动回调
        this.launch && this.launch(param);
    }
}